/* Built In Imports */
/* External Imports */
import { Box, Center, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import config from '@config';
import SimpleButton from '@moms/Buttons/SimpleButton';
import TopBannerSt from '@moms/styleData/TopbannerSt';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';

/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const TopBannerEvent = ({ sectionContent, region, lang }) => {
  return (
    <Box
      height="100%"
      w="100%"
      backgroundImage={{
        base: sectionContent?.mobileImage?.url,
        md: sectionContent?.desktopImage?.url,
      }}
      bgRepeat="no-repeat"
      bgPos="center"
      bgSize="cover"
      pb={{ base: '80px', md: '40px' }}
      pt={{ base: '25px', md: '80px' }}
      px="20px"
      overflow="hidden"
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
    >
      <Box w="100%">
        <Flex w="100%" maxW={1200} mx="auto">
          <Flex
            flexDir="column"
            flex={1}
            height="100%"
            justifyContent="center"
            alignItems={{ base: 'center', md: 'flex-start' }}
            mt={{ base: '0', md: '60px' }}
            w={{ base: '100%', md: '50%' }}
          >
            {/* <Heading
              color="#fff"
              fontWeight={500}
              fontStyle="normal"
              textAlign={{ base: 'center', md: 'left' }}
              {...TopBannerSt[lang].heading}
            >
              {sectionContent.title.split(' ').map((title, index) => (
                <Text
                  as="span"
                  key={nanoid()}
                  fontStyle={index == '0' ? 'italic' : 'normal'}
                >
                  {title}{' '}
                </Text>
              ))}
            </Heading> */}
            <Image
              w="auto"
              height="auto"
              maxW={{
                base: '100px',
                md: '185px',
                lg: '300px',
                xl: '290px',
                '2xl': '350px',
              }}
              src={`${config.imgPath}/d/46272/1739879389-group-1597883432.png`}
              mb="20px"
            />
            <Flex
              flex={1}
              display={{ base: 'flex', md: 'none' }}
              w="100%"
              pos="relative"
              _before={{
                content: "''",
                width: '60%',
                height: '60%',
                background: '#678ECC',
                filter: 'blur(100px)',
                left: '20%',
                top: '20%',
                transform: 'rotate(25.738deg)',
                mixBlendMode: 'lighten',
                pos: 'absolute',
                zIndex: 0,
                borderRadius: '265.56px',
              }}
            >
              {/* <Box
                bg="transparent"
                w="100%"
                height="auto"
                minH={350}
                mt="-50px"
                as="iframe"
                src="https://my.spline.design/mobilemockup-f8368e951ee657df6b578a490e6c1169/"
              ></Box> */}
              <Center
                height={{ base: 'auto', sm: 500, lg: 700 }}
                maxH="45vh"
                w="100%"
                // mt="-100px"
                pos="relative"
                zIndex={2}
              >
                {/* <MobileMockup /> */}
                <Image
                  src={`${config.imgPath}/d/46272/1739879389-mobile-mockup-10-600x1086-2.png`}
                  width="auto"
                  height="auto"
                  maxH="100%"
                  maxW="100%"
                  objectFit="contain"
                  objectPosition="center"
                  verticalAlign="middle"
                />
              </Center>
              {/* <div>
                <Spline scene="https://prod.spline.design/6Wq1Q7YGyM-iab9i/scene.splinecode" />
              </div> */}
              {/* <MobileMockup /> */}
            </Flex>
            <StructuredTextParser
              str={render(sectionContent.titleSubtext)}
              color="#fff"
              textAlign={{ base: 'center', md: 'left' }}
              mt={{
                base: '1rem',
                md: '20px',
                lg: '40px',
                xl: '30px',
                '2xl': '50px',
              }}
              mb={{ base: '.4rem', md: '0' }}
              {...TopBannerSt[lang].titleSubtext}
            />
            <StructuredTextParser
              str={render(sectionContent.closedMessage)}
              background="linear-gradient(270deg, #EC2224 0%, #636EFF 100%)"
              sx={{ textFillColor: 'transparent', backgroundClip: 'text' }}
              textAlign={{ base: 'center', md: 'left' }}
              // letterSpacing="-3.2px"
              // -webkit-background-clip: text;
              mt={{ base: '1rem', md: '-10px' }}
              {...TopBannerSt[lang].closedMessage}
            />
            <Box
              display="block"
              width={{ base: '100%', sm: '350px', lg: '450px' }}
            >
              <SimpleButton
                mx={{ base: 'auto', sm: '0' }}
                mb="12px"
                height={{ base: '56px', md: 'auto' }}
                display={{ base: 'flex' }}
                fontWeight={600}
                borderWidth={'1px'}
                border={'none'}
                borderRadius={'55px'}
                w={{ base: '100%', sm: '350px', lg: '435px' }}
                minW="280px"
                _hover={{ bgColor: '#DBDBDB' }}
                bgColor={'#FFFFFF'}
                mt={{ base: '2.5rem', md: '30px' }}
                style={sectionContent.button[0]}
                region={region}
                lang={lang}
                py="21px"
                textAlign="center"
                alignItems="center"
                justifyContent="center"
                {...TopBannerSt[lang].buttonSt}
              />
            </Box>
            <StructuredTextParser
              str={render(sectionContent.bottomText)}
              color="#fff"
              textAlign={{ base: 'center', md: 'left' }}
              {...TopBannerSt[lang].bottomText}
            />
          </Flex>
          <Flex
            flex={1}
            display={{ base: 'none', md: 'flex' }}
            w={{ base: '100%', md: '50%' }}
            pos="relative"
            _before={{
              content: "''",
              width: '60%',
              height: '60%',
              background: '#678ECC',
              filter: 'blur(100px)',
              left: '20%',
              top: '40%',
              transform: 'rotate(25.738deg)',
              mixBlendMode: 'lighten',
              pos: 'absolute',
              zIndex: 0,
              borderRadius: '265.56px',
            }}
          >
            <Flex
              height={{ base: 400, sm: '100%', lg: '65vh', XL: '80vh' }}
              w="100%"
              maxW={384}
              pos="relative"
              zIndex={1}
              alignSelf="center"
              mx="auto"
            >
              {/* <MobileMockup /> */}
              <Image
                src={`${config.imgPath}/d/46272/1739879389-mobile-mockup-10-600x1086-2.png`}
                width="auto"
                height="auto"
                h="100%"
                maxW="100%"
                objectFit="contain"
                objectPosition="center"
                verticalAlign="middle"
                ml="auto"
              />
            </Flex>
            {/* <div>
              <Spline scene="https://my.spline.design/mobilemockup-f8368e951ee657df6b578a490e6c1169" />
            </div> */}
            {/* <MobileMockup /> */}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
export default TopBannerEvent;
